module.exports = __webpack_public_path__ + "img/Safari.081fb23b.svg";